module.exports = __webpack_public_path__ + "static/media/wan-ding-yao.0d15ad14.jpg";